package com.findyourbuddies.website.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.objectFit
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Text

@Composable
fun AppFooter() {
    Footer(
        attrs = {
            style {
                property(
                    "background-image",
                    "linear-gradient(135deg, rgb(157, 179, 218) 0%, rgb(98, 131, 178) 100%)"
                )
                property("border-top-left-radius", "16px")
                property("border-top-right-radius", "16px")
                property("width", "100%")
                property("box-sizing", "border-box")
                property("padding", "24px")
            }
        }
    ) {
        Column(
            modifier = Modifier.fillMaxWidth().gap(10.px),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Row(
                modifier = Modifier.gap(16.px),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                Img(
                    src = "/images/logo.svg",
                    alt = "Find Your Buddies Logo",
                    attrs = {
                        style {
                            width(30.px)
                            objectFit(ObjectFit.Fill)
                        }
                    }
                )

                SpanText(
                    "fyb",
                    modifier = Modifier
                        .fontSize(24.px)
                        .fontWeight(FontWeight.Bold)
                        .color(Colors.White)
                        .fontFamily("Waxe", "Arial", "sans-serif"),
                )
            }

            Row(
                modifier = Modifier.gap(16.px)
            ) {
                FooterLink("Terms of Service", "/terms-of-service")
                FooterLink("Privacy Policy", "/privacy-policy")
                FooterLink("Contact", "mailto:contact@findyourbuddies.com")
            }

            SocialLinks()

            SpanText(
                "© ${kotlin.js.Date().getFullYear()} FindYourBuddies. All rights reserved.",
                Modifier
                    .fontSize(10.px)
                    .color(Colors.White)
                    .fontFamily("Comfortaa", "Arial", "sans-serif")
            )
        }
    }
}

@Composable
fun FooterLink(text: String, url: String) {
    A(
        href = url,
        attrs = {
            style {
                color(Colors.White)
                textDecoration("none")
                fontSize(10.px)
                fontFamily("Comfortaa", "Arial", "sans-serif")
            }
        }
    ) {
        Text(text)
    }
}

@Composable
fun SocialIcon(iconPath: String, link: String) {
    A(
        href = link,
        attrs = {
            style {
                display(DisplayStyle.InlineBlock)
                width(32.px)
                height(32.px)
            }
        }
    ) {
        Img(src = iconPath, attrs = {
            style {
                width(32.px)
                height(32.px)
            }
        })
    }
}
